import React, { useState, useEffect } from 'react';
import { gameAPI } from '../api';

const GameHistory = () => {
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const fetchHistory = async (pageNum = 1) => {
    setLoading(true);
    try {
      const res = await gameAPI.getHistory(pageNum, 10);
      setHistory(res.data.history);
      setTotalPages(res.data.pages);
      setPage(res.data.page);
    } catch (err) {
      console.error('获取历史记录失败', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchHistory(1);
  }, []);

  const handlePrev = () => {
    if (page > 1) fetchHistory(page - 1);
  };
  const handleNext = () => {
    if (page < totalPages) fetchHistory(page + 1);
  };

  if (loading) return <div style={{ textAlign: 'center', padding: '20px' }}>加载历史记录中...</div>;

  return (
    <div className="card" style={{ marginTop: '30px', padding: '20px' }}>
      <h3 style={{ marginTop: 0 }}>📜 历史对战</h3>
      {history.length === 0 ? (
        <p>暂无对战记录，快去匹配一局吧！</p>
      ) : (
        <>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ borderBottom: '2px solid var(--color-border-primary)' }}>
                <th style={{ padding: '8px', textAlign: 'left' }}>时间</th>
                <th style={{ padding: '8px', textAlign: 'left' }}>对手</th>
                <th style={{ padding: '8px', textAlign: 'center' }}>结果</th>
                <th style={{ padding: '8px', textAlign: 'right' }}>我方得分</th>
                <th style={{ padding: '8px', textAlign: 'right' }}>对手得分</th>
              </tr>
            </thead>
            <tbody>
              {history.map(record => (
                <tr key={record.id} style={{ borderBottom: '1px solid var(--color-border-primary)' }}>
                  <td style={{ padding: '8px' }}>{record.played_at}</td>
                  <td style={{ padding: '8px' }}>{record.opponent}</td>
                  <td style={{ padding: '8px', textAlign: 'center' }}>
                    {record.result === 'win' ? '胜利' : record.result === 'lose' ? '失败' : '平局'}
                  </td>
                  <td style={{ padding: '8px', textAlign: 'right' }}>{record.user_score}</td>
                  <td style={{ padding: '8px', textAlign: 'right' }}>{record.opponent_score}</td>
                </tr>
              ))}
            </tbody>
          </table>
          <div style={{ display: 'flex', justifyContent: 'center', gap: '16px', marginTop: '20px' }}>
            <button onClick={handlePrev} disabled={page <= 1} className="btn btn-secondary">上一页</button>
            <span>第 {page} / {totalPages} 页</span>
            <button onClick={handleNext} disabled={page >= totalPages} className="btn btn-secondary">下一页</button>
          </div>
        </>
      )}
    </div>
  );
};

export default GameHistory;